<template>
  <div class="wrap">
    <div class="title"></div>
    <div class="echarts-wrap" ref="chart"></div>
  </div>
</template>

<script>
  import {echartsMixin} from 'assets/js/common/mixin'
  export default {
    name: "worth",
    mixins: [echartsMixin],
    data() {
      return {
        echartsData: {
        	worth:[22, 26, 25, 28, 20, 26, 22, 24, 23, 26, 21,22],
        	decline:[2.2, 2.6, 2.5, 2.8, 2.0, 2.6, 2.2, 2.4, 2.3, 2.6, 2.1,2.2],
        	rise:[2.2, 2.6, 2.5, 2.8, 2.0, 2.6, 2.2, 2.4, 2.3, 2.6, 2.1,2.2]
        }
      }
    },
    watch: {
      echartsData: {
        handler: function (val, oldVal) {
          this.initChart();
        },
        deep: true  //增加deep 观察对象的子对象变化
      }
    },
    mounted(){
      this.$nextTick(() => {
        this.myChart = this.$echarts.init(this.$refs.chart);
        this.initChart()
      })
    },
    methods:{
      initChart(){
        let datas = {
          datax:[],
          datas:[]
        }
        let option = {
          calculable : true,
          tooltip: {
            trigger: 'axis',
            formatter:(params)=>{
							let html = "<div style='padding:15px'><p style='text-align:center;font-Weight:bold'>"+params[0].name+"</p>"
								html+=`${params[0].seriesName}：<span style="color:#4CD5FF">${params[0].data}</span><br/>
								       环比上涨：<span style="color:#4CD5FF">${this.echartsData.rise[params[0].dataIndex]}</span><br/>
								       同比下降：<span style="color:#4CD5FF">${this.echartsData.decline[params[0].dataIndex]}</span>`

							return html+'</div>'
						},
            backgroundColor:"#002624",
						borderColor:'#009288',
						borderWidth:1,
            textStyle:{
							color:"#fff",
						},
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'line',        // 默认为直线，可选为：'line' | 'shadow'
              lineStyle:{
                color: '#FFBD2E',
                width:2,
                type:"dashed"
              }
            },
          },
          grid: {
						left: '5%',
						right: '4%',
						bottom: '19%',
						top: "14%",
						containLabel: true
					},
          dataZoom: [{
            show: true,
            height: 12,
            xAxisIndex: [0],
            left: '90',
            right: '70',
            bottom: "13%",
            backgroundColor: '#081211',
            dataBackground: {
              areaStyle: {
                color: 'rgba(79, 140, 210, 0.4)'
              },
              lineStyle: {
                opacity: 0.8,
                color: '#8392A5'
              }
            },
            fillerColor: '#23A199',
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%',
            handleStyle: {
              color: '#00ADFA',
              shadowBlur: 0,
              shadowColor: 'rgba(255, 0, 0, 1)',
              shadowOffsetX: 0,
              shadowOffsetY: 0
            },
            textStyle: {
              color: "#11caff",
              fontSize: '12'
            },
            borderColor: "#3458B4"
          }, {
             type: "inside",
             show: true,

          }],
          xAxis: {
            name:'',
            nameTextStyle:{
              color:'#fff'
            },

            type: 'category',
            boundaryGap: false,//折线距离y轴有无距离
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: "#fff",
                fontFamily: "微软雅黑",
                textAlign: 'right'
              },
              margin: 10
            },
            axisTick: {
              show:false
            },

            axisLine: {
              lineStyle: {
                color: "#35ece6",
                type: "solid",
                width: 1
              }
            },

            data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],

          },
          yAxis: {
            name:'评估指数',
            nameTextStyle:{
              color:'#fff'
            },
            type: 'value',
            //min: 0,
            //max: 100,
            //interval: 20,
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 12,
                color: "#fff",
                fontFamily: "微软雅黑"
              },
              formatter:'{value}',
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#35ece6",
                type: "solid",
                opacity:1
              }
            },
            splitLine: {
              lineStyle: {
                color: '#17a096', //分割线颜色
                type: "solid",
                width:1
              }
            }
          },
          lineStyle:{
            normal:{
              color:'#0654b8'
            }
          },
          itemStyle:{
            normal:{
              color:'#00a6ff',
              borderWidth:'2'
            }
          },

          series : [
            {
              name:'土地价值评估指数',
              type:'line',
              smooth:false,
              lineStyle:{
              	color:"#35ECE6",
              },
              itemStyle: {
              	normal: {
              		color:"pink",
              		borderColor:"#35ECE6",
              		borderWidth:2,
               },
               emphasis:{
               	  borderColor:"#FFBD2E",
              		borderWidth:2,
//             	  color:"#081211"
               }
              },
              data:this.echartsData.worth,
              symbolSize: 8,
              areaStyle:{
                normal:{
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0.7,
                    color: 'rgba(0,255,203,0.83)'
                  }, {
                    offset: 1,
                    color: 'rgba(0,209,255,0.83)'
                  }]),
                  opacity:0.2

                }
              }
            },
          ]
        };
        this.myChart.setOption(option);
      },
      // echats 图表自适应
      _resizeHanlder() {
        this.myChart.resize()
      },
      // 销毁echats图表方法
      _destroyHandler() {
        if (this.myChart) {
          this.myChart.dispose()
        }
      }
    }
  }
</script>

<style scoped>
  .wrap{
    border:1px solid #03897f;
    height: 433px;
    box-sizing: border-box;
    background-color: #002624;
  }
  .title{
    height: 30px;
    background-image: linear-gradient(to right,#009990,#013939);

  }
  .echarts-wrap{
    width: 100%;
    height: calc(100% - 30px);
  }
</style>



// WEBPACK FOOTER //
// src/pages/transaction/worth.vue